<template>
  <section class="features-extended section">
    <div class="features-extended-inner section-inner">
      <div class="features-extended-wrap">
        <div class="container-herohire">
          <div class="feature-extended">
            <div class="feature-extended-image">
              <div class="mockup-bg">
                <img
                    src="@/assets/iphone-feature-bg-01.svg"
                    alt="iPhone Feature 01 illustration">
              </div>
              <div
                  class="type-bg"
                  style="position:relative;">
                <img
                    class="device-mockup is-revealing"
                    src="@/assets/all-trades-iphone-03.png"
                    alt="iPhone Feature 01">
              </div>
            </div>
            <div class="feature-extended-body is-revealing">
              <h3 class="mt-0 mb-16">
                Heroes for your everyday life.
              </h3>
              <p class="m-0 text-white">
                Struggling to find handymen, designers, or even mechanics?
                We have a wide range of different
                <span
                    class="text-primary-branded">Heroes</span>
                , catering for your every need.
              </p>
            </div>
          </div>
          <div class="feature-extended">
            <div class="feature-extended-image">
              <div class="mockup-bg">
                <img
                    src="@/assets/iphone-feature-bg-02.svg"
                    alt="iPhone Feature 02 illustration">
              </div>
              <img
                  class="device-mockup is-revealing"
                  src="@/assets/iphone-hero-question-03.png"
                  alt="iPhone Feature 02">
            </div>
            <div class="feature-extended-body is-revealing">
              <h3 class="mt-0 mb-16">
                The right information. Fast.
              </h3>
              <p class="m-0 text-white">
                Finding the right
                <span class="text-primary-branded">Hero</span> is quick and easy -
                look for what you need and get instant access to their e-mail, phone number and social media pages.
              </p>
            </div>
          </div>
          <div class="feature-extended">
            <div class="feature-extended-image">
              <div class="mockup-bg">
                <img
                    src="@/assets/iphone-feature-bg-03.svg"
                    alt="iPhone Feature 03 illustration">
              </div>
              <img
                  class="device-mockup is-revealing"
                  src="@/assets/superheroes-iphone-02.png"
                  alt="iPhone Feature 03">
            </div>
            <div class="feature-extended-body is-revealing">
              <h3 class="mt-0 mb-16">
                Empowered by our Superheroes
              </h3>
              <p class="m-0 text-white">
                Our
                <span class="text-primary-branded">Superheroes</span> are the core of the app. People like you are
                needed to provide services to others.
              </p>
            </div>
          </div>
          <div class="feature-extended">
            <div class="feature-extended-image">
              <div class="mockup-bg">
                <img
                    src="@/assets/iphone-feature-bg-04.svg"
                    alt="iPhone Feature 04 illustration">
              </div>
              <img
                  class="device-mockup is-revealing"
                  src="@/assets/iphone-hero-plus-04.png"
                  alt="iPhone Feature 04">
            </div>
            <div class="feature-extended-body is-revealing">
              <h3 class="mt-0 mb-16">
                Not all heroes wear capes.
              </h3>
              <p class="m-0 text-white">
                <span class="text-primary-branded">Hero Hire</span> is constantly being upgraded and improved
                with every new version. Have a cool feature that you would like to suggest to us?
                <a
                    href="https://koffeestudios.com"
                    class="text-primary-2">
                  Let us know.
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style lang="scss">
</style>
